module.exports = __webpack_public_path__ + "assets/fonts/JHS_Logo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/JHS_Logo.svg
// module id = 526
// module chunks = 0